import { Tage } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { Mitarbeiter_DayOfWeek } from '@/gql/graphql';

// oxlint-disable-next-line complexity
export function mapArbeitstage(
  arbeitstag: Tage[keyof Tage],
): Mitarbeiter_DayOfWeek {
  switch (arbeitstag) {
    case 0:
      return Mitarbeiter_DayOfWeek.Monday;
    case 1:
      return Mitarbeiter_DayOfWeek.Tuesday;
    case 2:
      return Mitarbeiter_DayOfWeek.Wednesday;
    case 3:
      return Mitarbeiter_DayOfWeek.Thursday;
    case 4:
      return Mitarbeiter_DayOfWeek.Friday;
    case 5:
      return Mitarbeiter_DayOfWeek.Saturday;
    case 6:
      return Mitarbeiter_DayOfWeek.Sunday;
    default:
      throw new Error(`Unsupported day value: ${arbeitstag}`);
  }
}
